module.exports = __webpack_public_path__ + "static/media/yopen-register.c918bacc.svg";